<template>
  <div class="smart-select"
       :class="classList"
       v-on-clickaway="onLostFocus"
  >
    <div class="smart-select__warning-on-focus">
      <slot name="warningOnFocus"></slot>
    </div>
    <label @click="onClick">
      <div class="placeholder">{{ placeholder }}</div>
      <div class="smart-select__value">{{ value }}</div>
    </label>
    <div class="dropdown" v-if="isFocus && !disabled">
      <div class="dropdown__item"
           v-for="(item, i) in options"
           :key="i"
           :class="{'is-selected': value === item[label] || value === item.text}"
           @click="onClickItem(item)">
        <slot name="item" :item="item"> {{ label ? item[label] : item.text }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'smartSelect',
  mixins: [clickaway],
  props: {
    options: Array,
    label: String,
    placeholder: String,
    value: String,
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocus: false,
      error: !this.notEmpty,
    };
  },
  computed: {
    texts() {
      return {
        required: this.$t('Required'),
      };
    },
    classList() {
      return {
        'is-focus': this.isFocus,
        'is-disabled': this.disabled,
        'is-error': !this.notEmpty,
        'not-empty': !!this.notEmpty,
        'dropdown-open': this.dropdownList && this.dropdownList.length > 0,
      };
    },
    notEmpty() {
      return !!this.value;
    },
    isError() {
      return !!this.error;
    },
  },
  watch: {
    notEmpty: {
      handler: 'errorHandler',
      immediate: true,
    },
  },
  methods: {
    errorHandler(notEmpty) {
      if (!notEmpty) {
        this.$emit('error', this.texts.required);
      } else {
        this.$emit('error', '');
      }
    },
    onClickItem(value) {
      this.onLostFocus();
      this.$emit('select', value);
    },
    onLostFocus() {
      this.isFocus = false;
    },
    onClick() {
      this.isFocus = true;
    },
  },
};
</script>

<style scoped lang="scss">
$inputLeftPadding: 24;
.smart-select {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  border-radius: 4px;
  background-color: #f0f0f0;
  border: 1px solid #f0f0f0;
  cursor: pointer;

  &.is-disabled {
    cursor: default;
  }

  &.is-error {
    background-color: #ffe6e6;
  }

  &__value {
    height: 52px;
    padding: 20px 24px 4px;
    color: #111111;
    font-size: 16px;
    font-weight: 300;
    line-height: 2;
    background-image: url('../../assets/icons/smart-select-arrow.png');
    background-repeat: no-repeat;
    background-position: right 16px center;

    .is-disabled & {
      background-image: none;
    }
  }

  &__warning-on-focus {
    position: absolute;
    top: -15px;
    right: 0;
    font-size: 11px;
    color: red;
    pointer-events: none;
    opacity: 0;
    transform: translateY(10px);
    transition: transform .35s ease, opacity .35s ease;

    .is-focus & {
      transform: translateY(0);
      opacity: 1;
    }
  }
}

label {
  display: block;
  cursor: inherit;
  overflow: hidden;
}

.placeholder {
  position: absolute;
  left: $inputLeftPadding * 1px;
  top: 50%;

  transform: translate(0, -50%) scale(1);
  transform-origin: left center;
  transition: transform .15s ease;

  color: #888888;
  font-size: 15px;
  font-weight: 300;
  pointer-events: none;
  max-width: calc(100% - #{$inputLeftPadding * 2px});
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .is-focus &,
  .not-empty & {
    transform: translate(0, -100%) scale((11 / 15));
  }
}

.dropdown {
  position: absolute;
  top: 100%;
  left: -1px;
  right: -1px;
  z-index: 4;
  max-height: 200px;
  overflow: auto;

  border: 1px solid #ffcc00;
  border-radius: 0 0 4px 4px;

  background: #fff;

  &__item {
    cursor: pointer;
    padding: 4px $inputLeftPadding * 1px;
    text-align: left;

    font-size: 15px;
    font-weight: 300;

    &:focus,
    &:hover {
      outline: none;
      background-color: #ffcc00;
    }
  }
}

.is-selected {
  background: rgba(255, 204, 0, 0.23);

}
</style>
